import React, { Component, useEffect, useState } from "react";
import ComponentAutoLoginMobile from "./ComponentAutoLoginMobile";
import ComponentAutoLoginWeb from "./ComponentAutoLoginWeb";
import { BrowserView, MobileView } from "react-device-detect";

const ComponentAutoLogin = () => {
  return (
    <>
      <BrowserView>
        <ComponentAutoLoginWeb></ComponentAutoLoginWeb>
      </BrowserView>
      <MobileView>
        <ComponentAutoLoginMobile></ComponentAutoLoginMobile>
      </MobileView>
    </>
  );
};

export default ComponentAutoLogin;
